import { create } from "zustand";

export const useExhibitorStore = create((set, get) => ({
  isApplying: false,
  applyStep: 1,
  selectedCategory: null,
  submittingApply: false,
  formFields: [],
  applyFormData: {},
  applyFormErrors: {},
  selectedBooth: null,
  isBoothPanelOpen: false,
  isSubmitted: false,

  setIsApplying: (val) => set({ isApplying: val }),
  setApplyStep: (val) => set({ applyStep: val }),
  setSelectedCategory: (val) => set({ selectedCategory: val }),
  setSubmittingApply: (val) => set({ submittingApply: val }),
  setFormFields: (val) => set({ formFields: val }),
  setIsSubmitted: (val) => set({ isSubmitted: val }),
  setApplyFormData: (val) =>
    set({
      applyFormData: typeof val === "function" ? val(get().applyFormData) : val,
    }),
  updateFormField: (fieldId, value) => {
    set((state) => ({
      applyFormData: { ...state.applyFormData, [fieldId]: value },
    }));
  },
  setApplyFormErrors: (val) =>
    set({
      applyFormErrors: typeof val === "function" ? val(get().applyFormErrors) : val,
    }),
  setSelectedBooth: (val) => set({ selectedBooth: val }),
  setIsBoothPanelOpen: (val) => set({ isBoothPanelOpen: val }),

  resetApplyForm: () => {
    const { formFields } = get();
    const resetData = {};
    formFields.forEach((f) => (resetData[f.id] = ""));
    set({
      isApplying: false,
      applyStep: 1,
      selectedCategory: null,
      applyFormData: resetData,
      applyFormErrors: {},
      selectedBooth: null,
      isSubmitted: false,
    });
  },
}));
